import React from 'react'

const Trier2 = () => {
  return (
    <div>this is Trier2 component</div>
  )
}

export default Trier2